import logo from './logo.svg';
import './App.css';
import React,{useEffect} from 'react'
import Home from './Pages/Home';
import {Routes,Route} from 'react-router-dom'
import Video from './Pages/Video';
import {useNavigate} from 'react-router-dom'
import CategoryPage from './Pages/CategoryPage';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import Tnc from './Pages/Tnc';

function App() {

  const GoToPage=()=>{
    const navigate = useNavigate()
    useEffect(() => {
      navigate('/kids-video')
    }, [])

    return(<></>);
  }


  return (
   <>
   <Routes>
   <Route path='/' element={<GoToPage/>}/>
    <Route path='/kids-video' element={<Home/>}/>
    <Route path='/kids-video/:id' element={<Video/>}/>
    <Route path='/Category/:category' element={<CategoryPage/>}/>
    <Route path='/tnc' element={<Tnc/>} />
   </Routes>
   </>
  );
}

export default App;
